import SmoothScrollIntoView from '../__utils/smoothScrollIntoView';
import setHeaderHeight from '../__utils/setHeaderHeight';
import setMobileFixedBottomButtonHeight from '../__utils/setMobileFixedBottomButtonHeight';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import delayedScripts from '../__utils/delayedScripts';
import stickyHeader from '../__utils/stickyHeader';
import stickyFooterButton from '../__utils/stickyFooterButton';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		setHeaderHeight();
		setMobileFixedBottomButtonHeight();
		viewportUnits();
		delayedScripts();
		stickyFooterButton();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		viewportUnits();
	},
	resized() {
		viewportUnits();
		setHeaderHeight();
		setMobileFixedBottomButtonHeight();
	},
	scrolled() {
		stickyHeader();
		stickyFooterButton();
	},
	keyDown() {},
	mouseUp() {},
};
export default controller;
